import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a534cc1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a534cc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a534cc1')) {
      api.createRecord('0a534cc1', component.options)
    } else {
      api.reload('0a534cc1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a534cc1&scoped=true&", function () {
      api.rerender('0a534cc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/index.vue"
export default component.exports